import script from "./reportData.vue?vue&type=script&setup=true&lang=ts"
export * from "./reportData.vue?vue&type=script&setup=true&lang=ts"

import "./reportData.vue?vue&type=style&index=0&id=6b8ffaf0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8ffaf0"]])

export default __exports__